module.exports = __webpack_public_path__ + "static/media/info_circle_blue.4b8a4026.svg";